/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 导入高单价商品数据 的 **请求配置**
 *
 * @分类 4180
 * @请求头 `POST /erp/AdminSetting/importHighGoodsNo`
 */
const postImportHighGoodsNoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/importHighGoodsNo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportHighGoodsNo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入高单价商品数据 的 **请求函数**
 *
 * @分类 4180
 * @请求头 `POST /erp/AdminSetting/importHighGoodsNo`
 */
export const postImportHighGoodsNo = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postImportHighGoodsNoRequestConfig, requestData),
    ...args
  );
};
postImportHighGoodsNo.requestConfig = postImportHighGoodsNoRequestConfig;
/**
 * 接口 导出高单价商品数据 的 **请求配置**
 *
 * @分类 4180
 * @请求头 `GET /erp/AdminSetting/exportHighGoodsNo`
 */
const getExportHighGoodsNoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/exportHighGoodsNo",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getExportHighGoodsNo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出高单价商品数据 的 **请求函数**
 *
 * @分类 4180
 * @请求头 `GET /erp/AdminSetting/exportHighGoodsNo`
 */
export const getExportHighGoodsNo = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getExportHighGoodsNoRequestConfig, requestData),
    ...args
  );
};
getExportHighGoodsNo.requestConfig = getExportHighGoodsNoRequestConfig;
/**
 * 接口 获取来货质检点货配置 的 **请求配置**
 *
 * @分类 4180
 * @请求头 `GET /erp/AdminSetting/getDaBiaoIntercept`
 */
const getGetDaBiaoInterceptRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/AdminSetting/getDaBiaoIntercept",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetDaBiaoIntercept",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取来货质检点货配置 的 **请求函数**
 *
 * @分类 4180
 * @请求头 `GET /erp/AdminSetting/getDaBiaoIntercept`
 */
export const getGetDaBiaoIntercept = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetDaBiaoInterceptRequestConfig, requestData),
    ...args
  );
};
getGetDaBiaoIntercept.requestConfig = getGetDaBiaoInterceptRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 获取售后配置 的 **请求配置**
 *
 * @分类 #4505
 * @请求头 `POST /erp/AdminSetting/getAfterSaleSetting`
 */
const postGetAfterSaleSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/AdminSetting/getAfterSaleSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetAfterSaleSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取售后配置 的 **请求函数**
 *
 * @分类 #4505
 * @请求头 `POST /erp/AdminSetting/getAfterSaleSetting`
 */
export const postGetAfterSaleSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetAfterSaleSettingRequestConfig, requestData),
    ...args
  );
};
postGetAfterSaleSetting.requestConfig = postGetAfterSaleSettingRequestConfig;
/**
 * 接口 保存售后配置 的 **请求配置**
 *
 * @分类 #4505
 * @请求头 `POST /erp/AdminSetting/setAfterSaleSetting`
 */
const postSetAfterSaleSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/AdminSetting/setAfterSaleSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetAfterSaleSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存售后配置 的 **请求函数**
 *
 * @分类 #4505
 * @请求头 `POST /erp/AdminSetting/setAfterSaleSetting`
 */
export const postSetAfterSaleSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetAfterSaleSettingRequestConfig, requestData),
    ...args
  );
};
postSetAfterSaleSetting.requestConfig = postSetAfterSaleSettingRequestConfig;
/**
 * 接口 导出售后拦截包裹配置用户id 的 **请求配置**
 *
 * @分类 #4505
 * @请求头 `POST /erp/AdminSetting/exportAfterSaleUserId`
 */
const postExportAfterSaleUserIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/AdminSetting/exportAfterSaleUserId",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportAfterSaleUserId",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出售后拦截包裹配置用户id 的 **请求函数**
 *
 * @分类 #4505
 * @请求头 `POST /erp/AdminSetting/exportAfterSaleUserId`
 */
export const postExportAfterSaleUserId = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportAfterSaleUserIdRequestConfig, requestData),
    ...args
  );
};
postExportAfterSaleUserId.requestConfig =
  postExportAfterSaleUserIdRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 获取退供百分百抵扣商家开关设置 的 **请求配置**
 *
 * @分类 #4509
 * @请求头 `GET /erp/AdminSetting/getRefundCreditSetting`
 */
const getGetRefundCreditSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/getRefundCreditSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetRefundCreditSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取退供百分百抵扣商家开关设置 的 **请求函数**
 *
 * @分类 #4509
 * @请求头 `GET /erp/AdminSetting/getRefundCreditSetting`
 */
export const getGetRefundCreditSetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetRefundCreditSettingRequestConfig, requestData),
    ...args
  );
};
getGetRefundCreditSetting.requestConfig =
  getGetRefundCreditSettingRequestConfig;
/**
 * 接口 设置退供100%抵扣商家设置 的 **请求配置**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/setRefundCreditSetting`
 */
const postSetRefundCreditSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/setRefundCreditSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetRefundCreditSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置退供100%抵扣商家设置 的 **请求函数**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/setRefundCreditSetting`
 */
export const postSetRefundCreditSetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetRefundCreditSettingRequestConfig, requestData),
    ...args
  );
};
postSetRefundCreditSetting.requestConfig =
  postSetRefundCreditSettingRequestConfig;
/**
 * 接口 导入设置百分百抵扣商家ID 的 **请求配置**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/importRefundCreditSupply`
 */
const postImportRefundCreditSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/importRefundCreditSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportRefundCreditSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入设置百分百抵扣商家ID 的 **请求函数**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/importRefundCreditSupply`
 */
export const postImportRefundCreditSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportRefundCreditSupplyRequestConfig, requestData),
    ...args
  );
};
postImportRefundCreditSupply.requestConfig =
  postImportRefundCreditSupplyRequestConfig;
/**
 * 接口 导出百分百抵扣的商家ID 的 **请求配置**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/exportRefundCreditSupply`
 */
const postExportRefundCreditSupplyRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/exportRefundCreditSupply",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportRefundCreditSupply",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出百分百抵扣的商家ID 的 **请求函数**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/exportRefundCreditSupply`
 */
export const postExportRefundCreditSupply = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportRefundCreditSupplyRequestConfig, requestData),
    ...args
  );
};
postExportRefundCreditSupply.requestConfig =
  postExportRefundCreditSupplyRequestConfig;
/**
 * 接口 设置退换货配置 的 **请求配置**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/setReturnExchangeConfig`
 */
const postSetReturnExchangeConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/setReturnExchangeConfig",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetReturnExchangeConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置退换货配置 的 **请求函数**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/setReturnExchangeConfig`
 */
export const postSetReturnExchangeConfig = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetReturnExchangeConfigRequestConfig, requestData),
    ...args
  );
};
postSetReturnExchangeConfig.requestConfig =
  postSetReturnExchangeConfigRequestConfig;
/**
 * 接口 导入设置退换货配置的商家 的 **请求配置**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/importReturnExchangeSupper`
 */
const postImportReturnExchangeSupperRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/importReturnExchangeSupper",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportReturnExchangeSupper",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入设置退换货配置的商家 的 **请求函数**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/importReturnExchangeSupper`
 */
export const postImportReturnExchangeSupper = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportReturnExchangeSupperRequestConfig, requestData),
    ...args
  );
};
postImportReturnExchangeSupper.requestConfig =
  postImportReturnExchangeSupperRequestConfig;
/**
 * 接口 获取退换货商家开关设置 的 **请求配置**
 *
 * @分类 #4509
 * @请求头 `GET /erp/AdminSetting/getRefundExchangeConfig`
 */
const getGetRefundExchangeConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/getRefundExchangeConfig",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetRefundExchangeConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取退换货商家开关设置 的 **请求函数**
 *
 * @分类 #4509
 * @请求头 `GET /erp/AdminSetting/getRefundExchangeConfig`
 */
export const getGetRefundExchangeConfig = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetRefundExchangeConfigRequestConfig, requestData),
    ...args
  );
};
getGetRefundExchangeConfig.requestConfig =
  getGetRefundExchangeConfigRequestConfig;
/**
 * 接口 导出退换货商家ID 的 **请求配置**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/exportReturnExchangeSupper`
 */
const postExportReturnExchangeSupperRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/AdminSetting/exportReturnExchangeSupper",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportReturnExchangeSupper",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出退换货商家ID 的 **请求函数**
 *
 * @分类 #4509
 * @请求头 `POST /erp/AdminSetting/exportReturnExchangeSupper`
 */
export const postExportReturnExchangeSupper = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportReturnExchangeSupperRequestConfig, requestData),
    ...args
  );
};
postExportReturnExchangeSupper.requestConfig =
  postExportReturnExchangeSupperRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 获取波次分播配置 的 **请求配置**
 *
 * @分类 #4626
 * @请求头 `GET /erp/AdminSetting/getCutByWaveSetting`
 */
const getGetCutByWaveSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/AdminSetting/getCutByWaveSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetCutByWaveSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取波次分播配置 的 **请求函数**
 *
 * @分类 #4626
 * @请求头 `GET /erp/AdminSetting/getCutByWaveSetting`
 */
export const getGetCutByWaveSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetCutByWaveSettingRequestConfig, requestData),
    ...args
  );
};
getGetCutByWaveSetting.requestConfig = getGetCutByWaveSettingRequestConfig;
/**
 * 接口 设置波次分播配置 的 **请求配置**
 *
 * @分类 #4626
 * @请求头 `POST /erp/AdminSetting/setCutByWaveSetting`
 */
const postSetCutByWaveSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/AdminSetting/setCutByWaveSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetCutByWaveSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置波次分播配置 的 **请求函数**
 *
 * @分类 #4626
 * @请求头 `POST /erp/AdminSetting/setCutByWaveSetting`
 */
export const postSetCutByWaveSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetCutByWaveSettingRequestConfig, requestData),
    ...args
  );
};
postSetCutByWaveSetting.requestConfig = postSetCutByWaveSettingRequestConfig;
const mockUrl_0_0_0_4 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_4 = "";
const prodUrl_0_0_0_4 = "";
const dataKey_0_0_0_4 = "data";
/**
 * 接口 获取微次快修配置 的 **请求配置**
 *
 * @分类 #4777
 * @请求头 `GET /erp/AdminSetting/getMicroQuickService`
 */
const getGetMicroQuickServiceRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/getMicroQuickService",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetMicroQuickService",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取微次快修配置 的 **请求函数**
 *
 * @分类 #4777
 * @请求头 `GET /erp/AdminSetting/getMicroQuickService`
 */
export const getGetMicroQuickService = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetMicroQuickServiceRequestConfig, requestData),
    ...args
  );
};
getGetMicroQuickService.requestConfig = getGetMicroQuickServiceRequestConfig;
/**
 * 接口 设置售后商品是否标记微次 的 **请求配置**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/setAsGoodsLabelMicroSetting`
 */
const postSetAsGoodsLabelMicroSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setAsGoodsLabelMicroSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetAsGoodsLabelMicroSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置售后商品是否标记微次 的 **请求函数**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/setAsGoodsLabelMicroSetting`
 */
export const postSetAsGoodsLabelMicroSetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetAsGoodsLabelMicroSettingRequestConfig, requestData),
    ...args
  );
};
postSetAsGoodsLabelMicroSetting.requestConfig =
  postSetAsGoodsLabelMicroSettingRequestConfig;
/**
 * 接口 导入次品分类 的 **请求配置**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/importGoodsCpCategory`
 */
const postImportGoodsCpCategoryRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/importGoodsCpCategory",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportGoodsCpCategory",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入次品分类 的 **请求函数**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/importGoodsCpCategory`
 */
export const postImportGoodsCpCategory = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportGoodsCpCategoryRequestConfig, requestData),
    ...args
  );
};
postImportGoodsCpCategory.requestConfig =
  postImportGoodsCpCategoryRequestConfig;
/**
 * 接口 设置根据商家可接受退换货商品比例生成微次 的 **请求配置**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/setSupplyAcceptRejectSetting`
 */
const postSetSupplyAcceptRejectSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setSupplyAcceptRejectSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetSupplyAcceptRejectSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置根据商家可接受退换货商品比例生成微次 的 **请求函数**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/setSupplyAcceptRejectSetting`
 */
export const postSetSupplyAcceptRejectSetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetSupplyAcceptRejectSettingRequestConfig, requestData),
    ...args
  );
};
postSetSupplyAcceptRejectSetting.requestConfig =
  postSetSupplyAcceptRejectSettingRequestConfig;
/**
 * 接口 设置不可生成微次的次品类型 的 **请求配置**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/setGoodsCpCategorySetting`
 */
const postSetGoodsCpCategorySettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/setGoodsCpCategorySetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetGoodsCpCategorySetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置不可生成微次的次品类型 的 **请求函数**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/setGoodsCpCategorySetting`
 */
export const postSetGoodsCpCategorySetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetGoodsCpCategorySettingRequestConfig, requestData),
    ...args
  );
};
postSetGoodsCpCategorySetting.requestConfig =
  postSetGoodsCpCategorySettingRequestConfig;
/**
 * 接口 次品尺码添加 的 **请求配置**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/addCpSize`
 */
const postAddCpSizeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/addCpSize",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postAddCpSize",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 次品尺码添加 的 **请求函数**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/addCpSize`
 */
export const postAddCpSize = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postAddCpSizeRequestConfig, requestData), ...args);
};
postAddCpSize.requestConfig = postAddCpSizeRequestConfig;
/**
 * 接口 次品尺码删除 的 **请求配置**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/deleteCpSize`
 */
const postDeleteCpSizeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/deleteCpSize",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postDeleteCpSize",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 次品尺码删除 的 **请求函数**
 *
 * @分类 #4777
 * @请求头 `POST /erp/AdminSetting/deleteCpSize`
 */
export const postDeleteCpSize = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postDeleteCpSizeRequestConfig, requestData), ...args);
};
postDeleteCpSize.requestConfig = postDeleteCpSizeRequestConfig;
/**
 * 接口 导出次品分类 的 **请求配置**
 *
 * @分类 #4777
 * @请求头 `GET /erp/AdminSetting/exportGoodsCpCategory`
 */
const getExportGoodsCpCategoryRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/AdminSetting/exportGoodsCpCategory",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getExportGoodsCpCategory",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出次品分类 的 **请求函数**
 *
 * @分类 #4777
 * @请求头 `GET /erp/AdminSetting/exportGoodsCpCategory`
 */
export const getExportGoodsCpCategory = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getExportGoodsCpCategoryRequestConfig, requestData),
    ...args
  );
};
getExportGoodsCpCategory.requestConfig = getExportGoodsCpCategoryRequestConfig;
const mockUrl_0_0_0_5 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_5 = "";
const prodUrl_0_0_0_5 = "";
const dataKey_0_0_0_5 = "data";
/**
 * 接口 设置不标记微次配置 的 **请求配置**
 *
 * @分类 #5313
 * @请求头 `POST /erp/AdminSetting/setMinorWhitelistConfig`
 */
const postSetMinorWhitelistConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_5,
  devUrl: devUrl_0_0_0_5,
  prodUrl: prodUrl_0_0_0_5,
  path: "/erp/AdminSetting/setMinorWhitelistConfig",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetMinorWhitelistConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置不标记微次配置 的 **请求函数**
 *
 * @分类 #5313
 * @请求头 `POST /erp/AdminSetting/setMinorWhitelistConfig`
 */
export const postSetMinorWhitelistConfig = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetMinorWhitelistConfigRequestConfig, requestData),
    ...args
  );
};
postSetMinorWhitelistConfig.requestConfig =
  postSetMinorWhitelistConfigRequestConfig;
/**
 * 接口 导入设置不标记微次配置的商家 的 **请求配置**
 *
 * @分类 #5313
 * @请求头 `POST /erp/AdminSetting/importMinorWhitelistSupper`
 */
const postImportMinorWhitelistSupperRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_5,
  devUrl: devUrl_0_0_0_5,
  prodUrl: prodUrl_0_0_0_5,
  path: "/erp/AdminSetting/importMinorWhitelistSupper",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportMinorWhitelistSupper",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入设置不标记微次配置的商家 的 **请求函数**
 *
 * @分类 #5313
 * @请求头 `POST /erp/AdminSetting/importMinorWhitelistSupper`
 */
export const postImportMinorWhitelistSupper = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportMinorWhitelistSupperRequestConfig, requestData),
    ...args
  );
};
postImportMinorWhitelistSupper.requestConfig =
  postImportMinorWhitelistSupperRequestConfig;
/**
 * 接口 导出不标记微次商家ID 的 **请求配置**
 *
 * @分类 #5313
 * @请求头 `POST /erp/AdminSetting/exportMinorWhitelistSupper`
 */
const postExportMinorWhitelistSupperRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_5,
  devUrl: devUrl_0_0_0_5,
  prodUrl: prodUrl_0_0_0_5,
  path: "/erp/AdminSetting/exportMinorWhitelistSupper",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportMinorWhitelistSupper",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出不标记微次商家ID 的 **请求函数**
 *
 * @分类 #5313
 * @请求头 `POST /erp/AdminSetting/exportMinorWhitelistSupper`
 */
export const postExportMinorWhitelistSupper = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportMinorWhitelistSupperRequestConfig, requestData),
    ...args
  );
};
postExportMinorWhitelistSupper.requestConfig =
  postExportMinorWhitelistSupperRequestConfig;
/**
 * 接口 获取不标记微次商家开关设置 的 **请求配置**
 *
 * @分类 #5313
 * @请求头 `GET /erp/AdminSetting/getMinorWhitelistConfig`
 */
const getGetMinorWhitelistConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_5,
  devUrl: devUrl_0_0_0_5,
  prodUrl: prodUrl_0_0_0_5,
  path: "/erp/AdminSetting/getMinorWhitelistConfig",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_5,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetMinorWhitelistConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取不标记微次商家开关设置 的 **请求函数**
 *
 * @分类 #5313
 * @请求头 `GET /erp/AdminSetting/getMinorWhitelistConfig`
 */
export const getGetMinorWhitelistConfig = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetMinorWhitelistConfigRequestConfig, requestData),
    ...args
  );
};
getGetMinorWhitelistConfig.requestConfig =
  getGetMinorWhitelistConfigRequestConfig;
const mockUrl_0_0_0_6 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_6 = "";
const prodUrl_0_0_0_6 = "";
const dataKey_0_0_0_6 = "data";
/**
 * 接口 导入 - 无数据退还商家  的 **请求配置**
 *
 * @分类 #5468
 * @请求头 `POST /erp/AdminSetting/importNoDataReturnBlacklistSupper`
 */
const postImportNoDataReturnBlacklistSupperRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/AdminSetting/importNoDataReturnBlacklistSupper",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportNoDataReturnBlacklistSupper",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入 - 无数据退还商家  的 **请求函数**
 *
 * @分类 #5468
 * @请求头 `POST /erp/AdminSetting/importNoDataReturnBlacklistSupper`
 */
export const postImportNoDataReturnBlacklistSupper = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportNoDataReturnBlacklistSupperRequestConfig, requestData),
    ...args
  );
};
postImportNoDataReturnBlacklistSupper.requestConfig =
  postImportNoDataReturnBlacklistSupperRequestConfig;
/**
 * 接口 导出 - 无数据退还商家  的 **请求配置**
 *
 * @分类 #5468
 * @请求头 `POST /erp/AdminSetting/exportNoDataReturnBlacklistSupper`
 */
const postExportNoDataReturnBlacklistSupperRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_6,
  devUrl: devUrl_0_0_0_6,
  prodUrl: prodUrl_0_0_0_6,
  path: "/erp/AdminSetting/exportNoDataReturnBlacklistSupper",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_6,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportNoDataReturnBlacklistSupper",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出 - 无数据退还商家  的 **请求函数**
 *
 * @分类 #5468
 * @请求头 `POST /erp/AdminSetting/exportNoDataReturnBlacklistSupper`
 */
export const postExportNoDataReturnBlacklistSupper = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportNoDataReturnBlacklistSupperRequestConfig, requestData),
    ...args
  );
};
postExportNoDataReturnBlacklistSupper.requestConfig =
  postExportNoDataReturnBlacklistSupperRequestConfig;
const mockUrl_0_0_0_7 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_7 = "";
const prodUrl_0_0_0_7 = "";
const dataKey_0_0_0_7 = "data";
/**
 * 接口 导入商家控款数量 的 **请求配置**
 *
 * @分类 4.55.0
 * @请求头 `POST /erp/AdminSetting/importPaymentControlConfig`
 */
const postImportPaymentControlConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_7,
  devUrl: devUrl_0_0_0_7,
  prodUrl: prodUrl_0_0_0_7,
  path: "/erp/AdminSetting/importPaymentControlConfig",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportPaymentControlConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入商家控款数量 的 **请求函数**
 *
 * @分类 4.55.0
 * @请求头 `POST /erp/AdminSetting/importPaymentControlConfig`
 */
export const postImportPaymentControlConfig = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportPaymentControlConfigRequestConfig, requestData),
    ...args
  );
};
postImportPaymentControlConfig.requestConfig =
  postImportPaymentControlConfigRequestConfig;
/**
 * 接口 导出商家控款数量 的 **请求配置**
 *
 * @分类 4.55.0
 * @请求头 `POST /erp/AdminSetting/exportPaymentControlConfig`
 */
const postExportPaymentControlConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_7,
  devUrl: devUrl_0_0_0_7,
  prodUrl: prodUrl_0_0_0_7,
  path: "/erp/AdminSetting/exportPaymentControlConfig",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportPaymentControlConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出商家控款数量 的 **请求函数**
 *
 * @分类 4.55.0
 * @请求头 `POST /erp/AdminSetting/exportPaymentControlConfig`
 */
export const postExportPaymentControlConfig = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportPaymentControlConfigRequestConfig, requestData),
    ...args
  );
};
postExportPaymentControlConfig.requestConfig =
  postExportPaymentControlConfigRequestConfig;
/**
 * 接口 下载导入商家控款模板 的 **请求配置**
 *
 * @分类 4.55.0
 * @请求头 `GET /erp/AdminSetting/downMerchantControlConfigTemplate`
 */
const getDownMerchantControlConfigTemplateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_7,
  devUrl: devUrl_0_0_0_7,
  prodUrl: prodUrl_0_0_0_7,
  path: "/erp/AdminSetting/downMerchantControlConfigTemplate",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getDownMerchantControlConfigTemplate",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 下载导入商家控款模板 的 **请求函数**
 *
 * @分类 4.55.0
 * @请求头 `GET /erp/AdminSetting/downMerchantControlConfigTemplate`
 */
export const getDownMerchantControlConfigTemplate = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getDownMerchantControlConfigTemplateRequestConfig, requestData),
    ...args
  );
};
getDownMerchantControlConfigTemplate.requestConfig =
  getDownMerchantControlConfigTemplateRequestConfig;
/**
 * 接口 商家控款设置操作日志 的 **请求配置**
 *
 * @分类 4.55.0
 * @请求头 `GET /erp/AdminSetting/getMerchantControlConfigLogs`
 */
const getGetMerchantControlConfigLogsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_7,
  devUrl: devUrl_0_0_0_7,
  prodUrl: prodUrl_0_0_0_7,
  path: "/erp/AdminSetting/getMerchantControlConfigLogs",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_7,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetMerchantControlConfigLogs",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 商家控款设置操作日志 的 **请求函数**
 *
 * @分类 4.55.0
 * @请求头 `GET /erp/AdminSetting/getMerchantControlConfigLogs`
 */
export const getGetMerchantControlConfigLogs = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getGetMerchantControlConfigLogsRequestConfig, requestData),
    ...args
  );
};
getGetMerchantControlConfigLogs.requestConfig =
  getGetMerchantControlConfigLogsRequestConfig;
const mockUrl_0_0_0_8 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_8 = "";
const prodUrl_0_0_0_8 = "";
const dataKey_0_0_0_8 = "data";
/**
 * 接口 导入售后关联用户ID 的 **请求配置**
 *
 * @分类 #6120
 * @请求头 `POST /erp/AdminSetting/importAfterSaleRelateUserId`
 */
const postImportAfterSaleRelateUserIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_8,
  devUrl: devUrl_0_0_0_8,
  prodUrl: prodUrl_0_0_0_8,
  path: "/erp/AdminSetting/importAfterSaleRelateUserId",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postImportAfterSaleRelateUserId",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导入售后关联用户ID 的 **请求函数**
 *
 * @分类 #6120
 * @请求头 `POST /erp/AdminSetting/importAfterSaleRelateUserId`
 */
export const postImportAfterSaleRelateUserId = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postImportAfterSaleRelateUserIdRequestConfig, requestData),
    ...args
  );
};
postImportAfterSaleRelateUserId.requestConfig =
  postImportAfterSaleRelateUserIdRequestConfig;
/**
 * 接口 导出售后关联用户ID 的 **请求配置**
 *
 * @分类 #6120
 * @请求头 `POST /erp/AdminSetting/exportAfterSaleRelateUserId`
 */
const postExportAfterSaleRelateUserIdRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_8,
  devUrl: devUrl_0_0_0_8,
  prodUrl: prodUrl_0_0_0_8,
  path: "/erp/AdminSetting/exportAfterSaleRelateUserId",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_8,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postExportAfterSaleRelateUserId",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 导出售后关联用户ID 的 **请求函数**
 *
 * @分类 #6120
 * @请求头 `POST /erp/AdminSetting/exportAfterSaleRelateUserId`
 */
export const postExportAfterSaleRelateUserId = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postExportAfterSaleRelateUserIdRequestConfig, requestData),
    ...args
  );
};
postExportAfterSaleRelateUserId.requestConfig =
  postExportAfterSaleRelateUserIdRequestConfig;
const mockUrl_0_0_0_9 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_9 = "";
const prodUrl_0_0_0_9 = "";
const dataKey_0_0_0_9 = "data";
/**
 * 接口 获取PDA拣货路径设置 的 **请求配置**
 *
 * @分类 4221
 * @请求头 `POST /erp/AdminSetting/getPdaPickRoutes`
 */
const postGetPdaPickRoutesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/AdminSetting/getPdaPickRoutes",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetPdaPickRoutes",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取PDA拣货路径设置 的 **请求函数**
 *
 * @分类 4221
 * @请求头 `POST /erp/AdminSetting/getPdaPickRoutes`
 */
export const postGetPdaPickRoutes = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetPdaPickRoutesRequestConfig, requestData),
    ...args
  );
};
postGetPdaPickRoutes.requestConfig = postGetPdaPickRoutesRequestConfig;
/**
 * 接口 设置PDA拣货路径 的 **请求配置**
 *
 * @分类 4221
 * @请求头 `POST /erp/AdminSetting/setPdaPickRoutes`
 */
const postSetPdaPickRoutesRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/AdminSetting/setPdaPickRoutes",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetPdaPickRoutes",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置PDA拣货路径 的 **请求函数**
 *
 * @分类 4221
 * @请求头 `POST /erp/AdminSetting/setPdaPickRoutes`
 */
export const postSetPdaPickRoutes = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetPdaPickRoutesRequestConfig, requestData),
    ...args
  );
};
postSetPdaPickRoutes.requestConfig = postSetPdaPickRoutesRequestConfig;
/**
 * 接口 pda相关设置 的 **请求配置**
 *
 * @分类 4221
 * @请求头 `GET /erp/AdminSetting/pdaSetting`
 */
const getPdaSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/AdminSetting/pdaSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getPdaSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 pda相关设置 的 **请求函数**
 *
 * @分类 4221
 * @请求头 `GET /erp/AdminSetting/pdaSetting`
 */
export const getPdaSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getPdaSettingRequestConfig, requestData), ...args);
};
getPdaSetting.requestConfig = getPdaSettingRequestConfig;
/**
 * 接口 pda相关设置 的 **请求配置**
 *
 * @分类 4221
 * @请求头 `POST /erp/AdminSetting/pdaSetting`
 */
const postPdaSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_9,
  devUrl: devUrl_0_0_0_9,
  prodUrl: prodUrl_0_0_0_9,
  path: "/erp/AdminSetting/pdaSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_9,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPdaSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 pda相关设置 的 **请求函数**
 *
 * @分类 4221
 * @请求头 `POST /erp/AdminSetting/pdaSetting`
 */
export const postPdaSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postPdaSettingRequestConfig, requestData), ...args);
};
postPdaSetting.requestConfig = postPdaSettingRequestConfig;
const mockUrl_0_0_0_10 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_10 = "";
const prodUrl_0_0_0_10 = "";
const dataKey_0_0_0_10 = "data";
/**
 * 接口 获取质检改标配置 的 **请求配置**
 *
 * @分类 高级质检
 * @请求头 `GET /erp/AdminSetting/qualityLabelSetting`
 */
const getQualityLabelSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_10,
  devUrl: devUrl_0_0_0_10,
  prodUrl: prodUrl_0_0_0_10,
  path: "/erp/AdminSetting/qualityLabelSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getQualityLabelSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取质检改标配置 的 **请求函数**
 *
 * @分类 高级质检
 * @请求头 `GET /erp/AdminSetting/qualityLabelSetting`
 */
export const getQualityLabelSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getQualityLabelSettingRequestConfig, requestData),
    ...args
  );
};
getQualityLabelSetting.requestConfig = getQualityLabelSettingRequestConfig;
/**
 * 接口 保存质检改标配置 的 **请求配置**
 *
 * @分类 高级质检
 * @请求头 `POST /erp/AdminSetting/qualityLabelSetting`
 */
const postQualityLabelSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_10,
  devUrl: devUrl_0_0_0_10,
  prodUrl: prodUrl_0_0_0_10,
  path: "/erp/AdminSetting/qualityLabelSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_10,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postQualityLabelSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存质检改标配置 的 **请求函数**
 *
 * @分类 高级质检
 * @请求头 `POST /erp/AdminSetting/qualityLabelSetting`
 */
export const postQualityLabelSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postQualityLabelSettingRequestConfig, requestData),
    ...args
  );
};
postQualityLabelSetting.requestConfig = postQualityLabelSettingRequestConfig;
const mockUrl_0_0_0_11 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_11 = "";
const prodUrl_0_0_0_11 = "";
const dataKey_0_0_0_11 = "data";
/**
 * 接口 保存质检规则配置 的 **请求配置**
 *
 * @分类 多维度质检规则
 * @请求头 `POST /erp/AdminSetting/qualityRuleSettingSave`
 */
const postQualityRuleSettingSaveRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_11,
  devUrl: devUrl_0_0_0_11,
  prodUrl: prodUrl_0_0_0_11,
  path: "/erp/AdminSetting/qualityRuleSettingSave",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_11,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postQualityRuleSettingSave",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存质检规则配置 的 **请求函数**
 *
 * @分类 多维度质检规则
 * @请求头 `POST /erp/AdminSetting/qualityRuleSettingSave`
 */
export const postQualityRuleSettingSave = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postQualityRuleSettingSaveRequestConfig, requestData),
    ...args
  );
};
postQualityRuleSettingSave.requestConfig =
  postQualityRuleSettingSaveRequestConfig;
const mockUrl_0_0_0_12 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_12 = "";
const prodUrl_0_0_0_12 = "";
const dataKey_0_0_0_12 = "data";
/**
 * 接口 推送配置获取 的 **请求配置**
 *
 * @分类 三方仓支持前置仓
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingGet`
 */
const postPushTaskSettingGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_12,
  devUrl: devUrl_0_0_0_12,
  prodUrl: prodUrl_0_0_0_12,
  path: "/erp/AdminSetting/pushTaskSettingGet",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_12,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postPushTaskSettingGet",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 推送配置获取 的 **请求函数**
 *
 * @分类 三方仓支持前置仓
 * @请求头 `POST /erp/AdminSetting/pushTaskSettingGet`
 */
export const postPushTaskSettingGet = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postPushTaskSettingGetRequestConfig, requestData),
    ...args
  );
};
postPushTaskSettingGet.requestConfig = postPushTaskSettingGetRequestConfig;
const mockUrl_0_0_0_13 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_13 = "";
const prodUrl_0_0_0_13 = "";
const dataKey_0_0_0_13 = "data";
/**
 * 接口 精准质检-获取PC质检拦截质检配置 的 **请求配置**
 *
 * @分类 4318
 * @请求头 `POST /erp/AdminSetting/getQualityAccurate`
 */
const postGetQualityAccurateRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_13,
  devUrl: devUrl_0_0_0_13,
  prodUrl: prodUrl_0_0_0_13,
  path: "/erp/AdminSetting/getQualityAccurate",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetQualityAccurate",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 精准质检-获取PC质检拦截质检配置 的 **请求函数**
 *
 * @分类 4318
 * @请求头 `POST /erp/AdminSetting/getQualityAccurate`
 */
export const postGetQualityAccurate = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetQualityAccurateRequestConfig, requestData),
    ...args
  );
};
postGetQualityAccurate.requestConfig = postGetQualityAccurateRequestConfig;
/**
 * 接口 设置退换货商品不质检配置 的 **请求配置**
 *
 * @分类 4318
 * @请求头 `POST /erp/AdminSetting/setQualityRejectHold`
 */
const postSetQualityRejectHoldRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_13,
  devUrl: devUrl_0_0_0_13,
  prodUrl: prodUrl_0_0_0_13,
  path: "/erp/AdminSetting/setQualityRejectHold",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetQualityRejectHold",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置退换货商品不质检配置 的 **请求函数**
 *
 * @分类 4318
 * @请求头 `POST /erp/AdminSetting/setQualityRejectHold`
 */
export const postSetQualityRejectHold = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSetQualityRejectHoldRequestConfig, requestData),
    ...args
  );
};
postSetQualityRejectHold.requestConfig = postSetQualityRejectHoldRequestConfig;
/**
 * 接口 设置PC质检质检时间间隔配置 的 **请求配置**
 *
 * @分类 4318
 * @请求头 `POST /erp/AdminSetting/setQualityInterval`
 */
const postSetQualityIntervalRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_13,
  devUrl: devUrl_0_0_0_13,
  prodUrl: prodUrl_0_0_0_13,
  path: "/erp/AdminSetting/setQualityInterval",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_13,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetQualityInterval",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置PC质检质检时间间隔配置 的 **请求函数**
 *
 * @分类 4318
 * @请求头 `POST /erp/AdminSetting/setQualityInterval`
 */
export const postSetQualityInterval = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetQualityIntervalRequestConfig, requestData),
    ...args
  );
};
postSetQualityInterval.requestConfig = postSetQualityIntervalRequestConfig;
const mockUrl_0_0_0_14 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_14 = "";
const prodUrl_0_0_0_14 = "";
const dataKey_0_0_0_14 = "data";
/**
 * 接口 获取分播机配置 的 **请求配置**
 *
 * @分类 #4586
 * @请求头 `GET /erp/AdminSetting/getCutSetting`
 */
const getGetCutSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_14,
  devUrl: devUrl_0_0_0_14,
  prodUrl: prodUrl_0_0_0_14,
  path: "/erp/AdminSetting/getCutSetting",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetCutSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取分播机配置 的 **请求函数**
 *
 * @分类 #4586
 * @请求头 `GET /erp/AdminSetting/getCutSetting`
 */
export const getGetCutSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(getGetCutSettingRequestConfig, requestData), ...args);
};
getGetCutSetting.requestConfig = getGetCutSettingRequestConfig;
/**
 * 接口 设置分播机设置 的 **请求配置**
 *
 * @分类 #4586
 * @请求头 `POST /erp/AdminSetting/setCutSetting`
 */
const postSetCutSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_14,
  devUrl: devUrl_0_0_0_14,
  prodUrl: prodUrl_0_0_0_14,
  path: "/erp/AdminSetting/setCutSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_14,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetCutSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 设置分播机设置 的 **请求函数**
 *
 * @分类 #4586
 * @请求头 `POST /erp/AdminSetting/setCutSetting`
 */
export const postSetCutSetting = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSetCutSettingRequestConfig, requestData), ...args);
};
postSetCutSetting.requestConfig = postSetCutSettingRequestConfig;
const mockUrl_0_0_0_15 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_15 = "";
const prodUrl_0_0_0_15 = "";
const dataKey_0_0_0_15 = "data";
/**
 * 接口 获取全越设置 的 **请求配置**
 *
 * @分类 4940
 * @请求头 `POST /erp/AdminSetting/getAllSurpassSetting`
 */
const postGetAllSurpassSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_15,
  devUrl: devUrl_0_0_0_15,
  prodUrl: prodUrl_0_0_0_15,
  path: "/erp/AdminSetting/getAllSurpassSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetAllSurpassSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取全越设置 的 **请求函数**
 *
 * @分类 4940
 * @请求头 `POST /erp/AdminSetting/getAllSurpassSetting`
 */
export const postGetAllSurpassSetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetAllSurpassSettingRequestConfig, requestData),
    ...args
  );
};
postGetAllSurpassSetting.requestConfig = postGetAllSurpassSettingRequestConfig;
/**
 * 接口 保存全越配置 的 **请求配置**
 *
 * @分类 4940
 * @请求头 `POST /erp/AdminSetting/saveAllSurpassSetting`
 */
const postSaveAllSurpassSettingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_15,
  devUrl: devUrl_0_0_0_15,
  prodUrl: prodUrl_0_0_0_15,
  path: "/erp/AdminSetting/saveAllSurpassSetting",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSaveAllSurpassSetting",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存全越配置 的 **请求函数**
 *
 * @分类 4940
 * @请求头 `POST /erp/AdminSetting/saveAllSurpassSetting`
 */
export const postSaveAllSurpassSetting = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSaveAllSurpassSettingRequestConfig, requestData),
    ...args
  );
};
postSaveAllSurpassSetting.requestConfig =
  postSaveAllSurpassSettingRequestConfig;
/**
 * 接口 获取分播异常原因 的 **请求配置**
 *
 * @分类 4940
 * @请求头 `GET /erp/AdminSetting/getExceptionOps`
 */
const getGetExceptionOpsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_15,
  devUrl: devUrl_0_0_0_15,
  prodUrl: prodUrl_0_0_0_15,
  path: "/erp/AdminSetting/getExceptionOps",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_15,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getGetExceptionOps",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取分播异常原因 的 **请求函数**
 *
 * @分类 4940
 * @请求头 `GET /erp/AdminSetting/getExceptionOps`
 */
export const getGetExceptionOps = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(getGetExceptionOpsRequestConfig, requestData),
    ...args
  );
};
getGetExceptionOps.requestConfig = getGetExceptionOpsRequestConfig;
const mockUrl_0_0_0_16 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_16 = "";
const prodUrl_0_0_0_16 = "";
const dataKey_0_0_0_16 = "data";
/**
 * 接口 获取来货质检点货配置 的 **请求配置**
 *
 * @分类 来货质检
 * @请求头 `POST /erp/AdminSetting/getDaBiaoIntercept`
 */
const postGetDaBiaoInterceptRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_16,
  devUrl: devUrl_0_0_0_16,
  prodUrl: prodUrl_0_0_0_16,
  path: "/erp/AdminSetting/getDaBiaoIntercept",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetDaBiaoIntercept",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取来货质检点货配置 的 **请求函数**
 *
 * @分类 来货质检
 * @请求头 `POST /erp/AdminSetting/getDaBiaoIntercept`
 */
export const postGetDaBiaoIntercept = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetDaBiaoInterceptRequestConfig, requestData),
    ...args
  );
};
postGetDaBiaoIntercept.requestConfig = postGetDaBiaoInterceptRequestConfig;
/**
 * 接口 保存来货质检配置 的 **请求配置**
 *
 * @分类 来货质检
 * @请求头 `POST /erp/AdminSetting/setDaBiaoIntercept`
 */
const postSetDaBiaoInterceptRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_16,
  devUrl: devUrl_0_0_0_16,
  prodUrl: prodUrl_0_0_0_16,
  path: "/erp/AdminSetting/setDaBiaoIntercept",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_16,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetDaBiaoIntercept",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 保存来货质检配置 的 **请求函数**
 *
 * @分类 来货质检
 * @请求头 `POST /erp/AdminSetting/setDaBiaoIntercept`
 */
export const postSetDaBiaoIntercept = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postSetDaBiaoInterceptRequestConfig, requestData),
    ...args
  );
};
postSetDaBiaoIntercept.requestConfig = postSetDaBiaoInterceptRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/AdminSetting.js